import { TextInput, ReferenceInput, SelectInput } from 'react-admin';
import { PeriodFilter, Select1or0Filter } from '@/components/global/filters/filters.jsx';
import { productSources } from '@/components/product/productSources.jsx';
import CustomSelectArrayInput from '@/components/global/inputs/CustomSelectArrayInput';
import { TagReferenceArrayFilter } from '@/components/global/filters/TagReferenceArrayFilter.jsx';
import { productStatusChoices } from '@/components/global/options/selectOptions.jsx';
import FromToFilterComponent from '@/components/global/filters/FromToFilterComponent.jsx';

export const getProductFilters = (isMobile, translate) => [
    <PeriodFilter key='period' alwaysOn={true} className='period-filter' forceDesktopOnMobile={true} />,
    <SelectInput
        key='status'
        source='status'
        label={translate('common.status')}
        emptyText={translate('common.all')}
        choices={productStatusChoices(translate)}
        alwaysOn={isMobile}
    />,
    <TagReferenceArrayFilter
        key='tags'
        source='tags->id_in'
        reference='tag'
        label={translate('resources.product.labels.tags')}
        forceDesktopOnMobile={true}
        alwaysOn={isMobile}
    />,
    <TextInput key='brand' source='brand' label={translate('resources.product.labels.brand')} alwaysOn={isMobile} />,
    <Select1or0Filter key='ownerContractor' source='ownerContractor' label={translate('resources.product.labels.brandContractor')} alwaysOn={isMobile} />,
    <ReferenceInput key='materialId' source='materialId' reference='material' alwaysOn={isMobile} label={translate('resources.product.fields.material')}>
        <SelectInput alwaysOn={isMobile} emptyText={translate('common.all')} label={translate('resources.product.fields.material')} />
    </ReferenceInput>,
    <FromToFilterComponent
        key='volume'
        source='volume_range'
        label={translate('resources.product.filters.capacity')}
        forceDesktopOnMobile={true}
        alwaysOn={isMobile}
    />,
    <FromToFilterComponent
        key='totalWeight'
        source='totalWeight_range'
        label={translate('resources.product.fields.weight')}
        forceDesktopOnMobile={true}
        alwaysOn={isMobile}
    />,
    <FromToFilterComponent
        key='createdAt'
        source='createdAt_range'
        label={translate('resources.product.filters.addDate')}
        type='date'
        forceDesktopOnMobile={true}
        alwaysOn={isMobile}
    />,
    <CustomSelectArrayInput
        key='source'
        source='source_in'
        label={translate('resources.product.fields.source')}
        choices={productSources}
        forceDesktopOnMobile={true}
        alwaysOn={isMobile}
        emptyText={translate('common.all')}
    />,
    <Select1or0Filter key='reusable' source='reusable' label={translate('resources.product.labels.reusable')} alwaysOn={isMobile} />,
    <FromToFilterComponent
        key='deposit'
        source='deposit_range'
        label={translate('resources.product.fields.deposit')}
        forceDesktopOnMobile={true}
        alwaysOn={isMobile}
    />,
];
